import i18nFactory from '@yandex-int/i18n';

import {
    FreelancerFeedbackError,
    FreelancerFeedbackErrorCode
} from '../../actions/freelancers/freelancer-feedback';
import { NoticeType, showNoticeMessage } from '../../actions/grid-screen';

import * as keyset from './FreelancerFeedbackErrorHandler.i18n'; // import * as i18n from ' b:service_FreelancerFeedbackErrorHandler';
const i18n = i18nFactory(keyset);

export function freelancerFeedbackErrorHandler(
    errors: Array<FreelancerFeedbackError>
): Array<FreelancerFeedbackError> {
    return errors.reduce(
        (
            criticalErrors: Array<FreelancerFeedbackError>,
            err: FreelancerFeedbackError
        ) => {
            switch (err.code) {
                case FreelancerFeedbackErrorCode.INCORRECT_FEEDBACK_TEXT_SIZE:
                    showNoticeMessage(
                        NoticeType.warning,
                        i18n('incorrect-feedback-text-size')
                    );
                    return criticalErrors;
                case FreelancerFeedbackErrorCode.FEEDBACK_ALREADY_EXIST:
                    showNoticeMessage(
                        NoticeType.error,
                        i18n('feedback-already-exists')
                    );
                    return [...criticalErrors, err];
                case FreelancerFeedbackErrorCode.FEEDBACK_NOT_FOUND:
                    showNoticeMessage(
                        NoticeType.error,
                        i18n('feedback-not-found')
                    );
                    return [...criticalErrors, err];
                case FreelancerFeedbackErrorCode.OPERATOR_HAS_NO_PROJECT_WITH_FREELANCER:
                    showNoticeMessage(
                        NoticeType.error,
                        i18n('operator-has-no-project-with-freelancer')
                    );
                    return [...criticalErrors, err];
                case FreelancerFeedbackErrorCode.OPERATOR_HAS_WRONG_ROLE:
                    showNoticeMessage(
                        NoticeType.error,
                        i18n('operator-has-wrong-role')
                    );
                    return [...criticalErrors, err];
                case FreelancerFeedbackErrorCode.OPERATOR_IS_NOT_CHIEF:
                    showNoticeMessage(
                        NoticeType.error,
                        i18n('operator-is-not-chief')
                    );
                    return [...criticalErrors, err];
                default:
                    return criticalErrors;
            }
        },
        []
    );
}
